function SaltyImageSearchProductCard(props) {
    var React = props.react;
    var h = React.createElement;
    var p = props.product || {};
    // Same as wizzy-search-results-product [[id]]: Shopify variant id, not product id.
    var variantId = typeof window.resolveWizzyVariantId === 'function'
        ? window.resolveWizzyVariantId(p)
        : p.id;
    var groupId = p.groupId || p.singleVarientGroupId || '';
    var href = p.url || p.href || '';
    var name = p.name || p.title || '';
    var mainImage = p.mainImage || p.imageUrl || '';
    var hoverImage = p.hoverImage || p.hoverImageUrl || mainImage;
    var hasDiscount = !!p.discountPercentage;
    if (!p.productHandle) {
        var handleMatch = String(href).match(/\/products\/([^/?#]+)/);
        if (handleMatch) p.productHandle = decodeURIComponent(handleMatch[1]);
    }

    function onLinkClick(event) {
    if (typeof props.onProductClick === 'function') props.onProductClick(event, p);
    }

    // React remounts these forms, so theme.AjaxProduct binds do not stick.
    // Resolve a real variant id (product.js fallback) then POST like AjaxProduct.
    function showFormError(form, message) {
        var existing = form.querySelector('.errors');
        if (existing) existing.remove();
        if (!message) return;
        var errorDiv = document.createElement('div');
        errorDiv.className = 'errors text-center';
        errorDiv.textContent = message;
        form.appendChild(errorDiv);
        setTimeout(function () { if (errorDiv.parentNode) errorDiv.remove(); }, 1500);
    }

    function postCart(variantId) {
        var url = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        }).then(function (res) { return res.json(); });
    }

    function addImageSearchToCart(form) {
        if (!form || form.dataset.ajaxAdding === 'true') return;
        var btn = form.querySelector('.add-to-cart');
        var idInput = form.querySelector('input[name="id"], select[name="id"]');
        form.dataset.ajaxAdding = 'true';
        if (btn) btn.classList.add('btn--loading');
        showFormError(form, '');

        var resolveId = typeof window.fetchWizzyVariantId === 'function'
            ? window.fetchWizzyVariantId(p)
            : Promise.resolve(variantId);

        resolveId.then(function (id) {
            var selectedVariantId = Number(id);
            if (!selectedVariantId) throw { description: 'Cannot find variant' };
            if (idInput) idInput.value = String(selectedVariantId);
            return postCart(selectedVariantId).then(function (data) {
                if (data && data.status === 422 && p.productHandle) {
                    return fetch('/products/' + encodeURIComponent(p.productHandle) + '.js')
                        .then(function (res) { return res.ok ? res.json() : null; })
                        .then(function (json) {
                            var variants = json && json.variants;
                            if (!Array.isArray(variants) || !variants.length) throw data;
                            var next = null;
                            for (var i = 0; i < variants.length; i++) {
                                if (variants[i] && variants[i].available) { next = variants[i]; break; }
                            }
                            next = next || variants[0];
                            if (!next || !next.id || Number(next.id) === selectedVariantId) throw data;
                            if (idInput) idInput.value = String(next.id);
                            return postCart(next.id);
                        });
                }
                return data;
            });
        })
            .then(function (data) {
                if (data && data.status === 422) {
                    showFormError(form, data.description || data.message || 'Cannot find variant');
                    return;
                }
                if (typeof window.updatebubble === 'function') window.updatebubble();
                form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    bubbles: true,
                    detail: { product: data, addToCartBtn: btn }
                }));
                if (!window.theme || !theme.settings || theme.settings.cartType === 'page') {
                    var bar = document.querySelector('.cart_notification_bar');
                    if (bar) {
                        bar.classList.add('active');
                        setTimeout(function () { bar.classList.remove('active'); }, 4000);
                    }
                }
            })
            .catch(function (err) {
                showFormError(form, (err && (err.description || err.message)) || 'Add to cart failed');
            })
            .finally(function () {
                form.dataset.ajaxAdding = 'false';
                if (btn) btn.classList.remove('btn--loading');
            });
    }

    function onFormSubmit(event) {
        event.preventDefault();
        addImageSearchToCart(event.currentTarget);
    }

    function onBagClick(event) {
        event.preventDefault();
        event.stopPropagation();
        addImageSearchToCart(event.currentTarget.form || event.currentTarget.closest('form'));
    }

    return h(
    'li',
    {
        className: 'wizzy-result-product wizzy-product-' + (variantId || '') +
        (p.groupId ? ' has-variations wizzy-group-product-' + p.groupId : ''),
        title: name,
        'data-id': variantId,
        'data-groupId': groupId
    },
    h('div', {
        className: 'new-featured-collection-grid__item new-featured-collection__item',
        'data-product-id': groupId,
        'data-product-handle': p.productHandle,
        'data-helium-product-handle': p.productHandle
    },
        p.productSaleBadge
        ? h('span', { className: 'alpha custom-tag', style: { background: '#dd592a', border: '1px solid #dd592a' } }, p.productSaleBadge)
        : null,
        h('div', { className: 'new-product-card' },
        h('div', { className: 'new-product-card__wishlist', 'aria-label': 'Add to wishlist' },
            h('div', {
            className: 'flits-collection-page-wishlist-button',
            'data-flits-product-handle': p.productHandle,
            'data-flits-product-id': groupId,
            'data-flits-product-title': p.flitsProductTitle,
            'data-flits-product-image': mainImage,
            'data-flits-product-wsl-count': p.flitsWslCount,
            'data-flits-product-price': p.flitsProductPrice,
            'data-flits-product-discount': p.flitsProductDiscount,
            'data-flits-product-collections': p.flitsProductCollections,
            'data-flits-page-index': '0',
            'data-product-name': name,
            'data-flits-product-type': p.flitsProductType
            })
        ),
        h('div', { className: 'new-product-card__media-wrap' },
            h('a', { href: href, className: 'new-product-card__media', onClick: onLinkClick },
            h('img', { src: mainImage, alt: name, width: 1024, height: 1024, className: 'new-product-card__image new-product-card__image--primary', loading: 'lazy' }),
            h('img', { src: hoverImage, alt: name, width: 1024, height: 1024, className: 'new-product-card__image new-product-card__image--secondary', loading: 'lazy' })
            ),
            h('div', { className: 'product-block new-product-block-cart' },
            h('form', {
                method: 'post',
                action: '/cart/add',
                id: 'AddToCartForm-template--22488644813015__main-collection-' + groupId,
                className: 'product-single__form custom_main_pdp product-grid-item',
                encType: 'multipart/form-data',
                'data-add-addon': 'false',
                'data-template-name': 'collection',
                onSubmit: onFormSubmit
            },
                h('input', { type: 'hidden', name: 'form_type', value: 'product' }),
                h('input', { type: 'hidden', name: 'utf8', value: '\u2713' }),
                h('button', {
                type: 'button',
                name: 'add',
                className: 'new-product-card__bag-btn add-to-cart',
                'aria-label': 'Add to cart',
                'data-add-to-cart': '',
                'data-template-name': 'collection',
                'data-product-form-new': '',
                onClick: onBagClick
                },
                h('span', { 'data-add-to-cart-text': '', 'data-default-text': 'Add to cart' },
                    h('img', {
                    src: 'https://cdn.shopify.com/s/files/1/0644/2457/5191/files/icon.n-bag.svg?v=1788440368',
                    alt: 'cart_bag',
                    loading: 'lazy',
                    width: 42,
                    height: 42
                    })
                )
                ),
                h('input', { type: 'hidden', name: 'id', defaultValue: String(variantId || '') }),
                h('input', { type: 'hidden', name: 'product-id', value: groupId }),
                h('input', { type: 'hidden', name: 'section-id', value: 'template--22488644813015__main-collection' })
            )
            )
        ),
        h('a', { href: href, onClick: onLinkClick },
            h('div', { className: 'new-product-card__bottom' },
            h('div', { className: 'new-product-card__title-row' },
                h('h3', { className: 'new-product-card__title' }, name),
                h('div', { className: 'new-product-card__rating', 'data-product-name': name },
                p.presentReview
                    ? h('div', {
                        className: 'jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup',
                        'data-id': groupId,
                        'data-widget-name': 'preview_badge'
                    },
                        h('div', {
                        className: 'jdgm-prev-badge',
                        style: { display: 'none' },
                        'data-average-rating': p.averageRating,
                        'data-number-of-reviews': '1'
                        },
                        h('span', {
                            className: 'jdgm-prev-badge__stars',
                            'data-score': p.averageRating,
                            tabIndex: 0,
                            role: 'button',
                            'aria-label': String(p.averageRating) + ' stars'
                        }),
                        h('span', { className: 'jdgm-prev-badge__text' }, String(p.averageRating || ''))
                        )
                    )
                    : null
                )
            ),
            h('div', { className: 'new-product-card__price-row' },
                h('span', { className: 'new-product-card__price-main' }, ' Rs.' + (p.sellingPrice || '') + ' '),
                hasDiscount ? h('span', { className: 'new-product-card__price-compare' }, 'Rs.' + (p.price || '')) : null,
                hasDiscount ? h('span', { className: 'new-product-card__discount-badge' }, p.discountPercentage + '% OFF') : null
            )
            )
        )
        )
    )
    );
}

window.WizzyImageSearchUI.push({
    type: 'registerUI',
    feature: 'results',
    payload: {
        productCard: SaltyImageSearchProductCard
    }
});